import { render, staticRenderFns } from "./snapshotApiCalls.vue?vue&type=template&id=6709aaec&scoped=true"
import script from "./snapshotApiCalls.vue?vue&type=script&lang=js"
export * from "./snapshotApiCalls.vue?vue&type=script&lang=js"
import style0 from "./snapshotApiCalls.vue?vue&type=style&index=0&id=6709aaec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6709aaec",
  null
  
)

export default component.exports